/**
 * Placeholders for screens that arrive in later phases.
 *
 * The navigation links to them from the start, so they say what they will hold
 * and when, rather than 404ing or rendering an empty panel that reads as a bug.
 */

import { Link } from 'react-router-dom'

function Placeholder({ title, phase, children }: {
  title: string
  phase: string
  children: React.ReactNode
}) {
  return (
    <div className="card mx-auto max-w-lg p-8 text-center">
      <h1 className="text-xl font-semibold">{title}</h1>
      <p className="mt-2 text-sm text-ink-2">{children}</p>
      <p className="mt-4 text-xs text-ink-3">Arriving in {phase}.</p>
      <Link to="/" className="btn btn-neutral btn-sm mt-5">
        Back to the dashboard
      </Link>
    </div>
  )
}

export function NotFoundPage() {
  return (
    <Placeholder title="Not found" phase="no phase">
      That page does not exist.
    </Placeholder>
  )
}
